import { Button } from "@/ui-components/ui/button";
import { PageTitle, PageTitleContainer } from "@/ui-components/utils/menu-items/page-title";
import { Trash2Icon } from "lucide-react";
import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { InvoicesFetcher } from "./fetcher";

const Invoices = () => {
  const [searchParams] = useSearchParams();
  const [searchQuery] = useState(searchParams.toString() || `page=1`);
  const [reload, setReload] = useState(false);

  return (
    <div>
      <PageTitleContainer>
        <div className="flex flex-row justify-between items-center">
          <PageTitle>Rechnungen</PageTitle>
          <div className="flex flex-row gap-2">
            <Link to={`/invoices/delete`}>
              <Button variant="destructive" className="flex flex-row gap-2">
                <Trash2Icon className="w-4 h-4" /> Rechnungen löschen
              </Button>
            </Link>
            <Link to={`/invoices/create`}>
              <Button className="px-4 py-2 bg-blue-500 text-white rounded-md">+ Neue Rechnung</Button>
            </Link>
          </div>
        </div>
      </PageTitleContainer>
      <InvoicesFetcher searchQuery={searchQuery} setReload={setReload} reload={reload} />
    </div>
  );
};

export default Invoices;
